var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileAccessinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 11a2 2 0 012-2h10a2 2 0 012 2v18a2 2 0 01-2 2H15a2 2 0 01-2-2V11zm5.997 10.187l5.333-5.249-1.086-1.126-4.247 4.18-1.667-1.641-1.086 1.126 2.753 2.71zM20 27a1 1 0 100 2 1 1 0 000-2z",
    fill: "#0F0449"
  })));
}

export default SvgMobileAccessinline;